import { useTranslation } from '../../../../../utils/useTranslation';
import { WithHint } from '../../../../feedback/Tooltip';
import { Input } from '../../../../input/Input';
import { makeTextSuggest } from '../../../../input/makeTextSuggest';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import { ContentPromotionBudgetMetricsProps } from './types';

const InputWithSuggest = makeTextSuggest(Input);

export const ContentPromotionBudgetMetrics: React.FC<ContentPromotionBudgetMetricsProps> = ({
    required,
    counters,
    selectedCounters,
    onSelectCounter,
    onRemoveCounter,
    ...other
}) => {
    const t = useTranslation();
    const suggest = counters.reduce<Record<string, string>>(
        (items, counter) => ({
            ...items,
            [counter.id]: counter.domain,
        }),
        {},
    );

    const selectedItems = selectedCounters.reduce((res, id) => ({ ...res, [id]: suggest[id] }), {});

    return (
        <Wrapper {...other}>
            <Flex direction="row" alignItems="center">
                <Typography variant="body" weight="bold">
                    {t('Счётчики Яндекс Метрики')}
                </Typography>
                <WithHint
                    ml={1}
                    iconColor="var(--color-secondary)"
                    message={t(
                        'Счётчик отслеживает переходы и активность пользователей на сайте или в профиле организации. Благодаря счётчику вы можете оптимизировать рекламу на достижение целей и платить только за нужные действия пользователей. Можно выбрать только счетчики, к которым у вас есть доступ. Если у вас пока нет доступа, запросите его у владельца счетчика или воспользуйтесь смешенной кампании в кабинете Директа. Для этого в кампании на РСЯ добавьте объявления с ссылками как из постов в Ритме и убедитесь что площадка "Продвижение постов в Ритме" не находиться в исключенных.',
                    )}
                />
            </Flex>
            <Box pt={2} width="100%">
                <InputWithSuggest
                    variant="outline"
                    placeholder={t('Поиск счётчика')}
                    empty={t('Нет доступных счетчиков')}
                    suggest={suggest}
                    selectedItems={selectedItems}
                    onSelectItem={onSelectCounter}
                    onRemoveItem={onRemoveCounter}
                    required={required}
                />
            </Box>
        </Wrapper>
    );
};
